var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIconSave(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "24px",
    height: "24px",
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Assets",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "assets",
    transform: "translate(-763.000000, -1567.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "icon/save",
    transform: "translate(763.000000, 1567.000000)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "bound",
    x: 0,
    y: 0,
    width: 24,
    height: 24
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.9,10 L18.9,10 C19.4522847,10 19.9,10.4477153 19.9,11 L19.9,13 C19.9,13.5522847 19.4522847,14 18.9,14 L13.9,14 L13.9,19 C13.9,19.5522847 13.4522847,20 12.9,20 L10.9,20 C10.3477153,20 9.9,19.5522847 9.9,19 L9.9,14 L4.9,14 C4.34771525,14 3.9,13.5522847 3.9,13 L3.9,11 C3.9,10.4477153 4.34771525,10 4.9,10 L9.9,10 L9.9,5 C9.9,4.44771525 10.3477153,4 10.9,4 L12.9,4 C13.4522847,4 13.9,4.44771525 13.9,5 L13.9,10 Z",
    id: "Path",
    fill: "#858199",
    fillRule: "evenodd"
  }))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconSave);
export default __webpack_public_path__ + "static/media/iconSave.c6681cd3.svg";
export { ForwardRef as ReactComponent };